// import React from "react";

// const InvoiceFooter = ({ data = {}, color = "primary", type = "main" }) => {
//   return <div>InvoiceFooter</div>;
// };

// export default InvoiceFooter;

import React from "react";
import { dateFormator } from "../../../../utils";

const InvoiceFooter = ({
  data = {},
  // color = "primary",
  color = "blueinvoice-footer",
  type = "main", // main, sub
  showText = true,
}) => {
  return data?.company ? (
    type === "main" ? (
      <div
        className={`header-main bg-${color} text-white flex justify-between items-end px-5 py-1 text-sm`}
      >
        {showText && "Footer"}
      </div>
    ) : (
      <div className="header-main bg-gray-50  text-gray-300 py-2 px-5 text-sm text-start">
        {data?.company?.name}
      </div>
    )
  ) : type === "main" ? (
    <div className="header-main bg-gray-50 text-center text-gray-300 py-2 px-5">
      {showText && "Footer"}
    </div>
  ) : (
    <div className="header-main bg-gray-50  text-gray-300 py-2 px-5 text-sm text-start">
      {dateFormator(new Date(), "day-shortMonth-year-time-utc")}
    </div>
  );
};

export default InvoiceFooter;
